
import {DynamicModal} from './DynamicModal';
import {Login} from '../user/Login';

let loginTpl = require('../templates/login.hbs');

export class Dialog extends DynamicModal {

  constructor(config) {
    super($.extend({
      id: 'dialog',
    }, config));
  }

  onSubmit() {
    if (this.config.closeOnSubmit !== false) {
      this.close();
    }
  }

  static confirm(title, content, options = {}) {

    if (!options.submitLabel)
      options.submitLabel = 'Ok';
    if (!options.submitStyle)
      options.submitStyle = 'success';

    return new Promise((resolve) => {

      let dialog = new Dialog({
        settings: {
          title,
          submitLabel: options.submitLabel,
          submitStyle: options.submitStyle,
          abortLabel: options.abortLabel,
        },
        content,
        preventClose: true,
      });

      dialog.on('close', (modal, dismiss) => {
        resolve(!dismiss);
      });
    });
  }

  /*
   * This function allows a click on the submit button to immediately trigger
   * window.open. This should prevent popup-Blockers from causing problems.
   */
  static confirmLink(title, content, url, target, options = {}) {

    if (!options.submitLabel)
      options.submitLabel = 'Ok';
    if (!options.submitStyle)
      options.submitStyle = 'success';

    return new Promise((resolve) => {

      let dialog = new Dialog({
        settings: {
          title,
          submitLabel: options.submitLabel,
          submitStyle: options.submitStyle
        },
        content,
        preventClose: true,
      });

      dialog.onSubmit = function() {
        window.open(url, target);
        if (this.config.closeOnSubmit !== false) {
          this.close();
        }
      };

      dialog.on('close', (modal, dismiss) => {
        resolve(!dismiss);
      });
    });
  }

  /**
   * Displays an information modal with given title and content.
   * @param title
   * @param content
   * @param options
   * @return {Promise<any>}
   */
  static info(title, content) {

    return new Promise((resolve) => {

      let dialog = new Dialog({
        settings: {
          title,
          hideFooter: true
        },
        content,
      });

      dialog.on('close', (modal, dismiss) => {
        resolve(!dismiss);
      });
    });
  }

  /**
   * Displays a modal with the login form.To be used if an user lost his session.
   * @param {Object} i18n - already translated message object
   * @param options
   * @return {Promise<any>}
   */
  static login(i18n, options = {}) {

    return new Promise((resolve) => {

      let content = loginTpl(i18n);
      let dialog = new Dialog({
        settings: {
          title: i18n.title,
          hideFooter: true,
        },
        content,
        preventClose: true,
        closeOnSubmit: false,
       });

      let login = new Login({
        app: options.app,
        el: dialog.el,
        disableRedirect: true,
        on: {
          success: () => {
            dialog.close();
          }
        }
      });
      login.setFormError(i18n.message);

      // prefill email if necessary
      if (options.email) {
        login.setFormData({
          email: options.email
        });
      }

      dialog.on('close', (modal, dismiss) => {
        resolve(!dismiss);
      });
    });
  }

}